export const orderActionTitle = 'Order action';
export const attLabel = 'AT&T';
